import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col px-3 gap-5 max-w-[40rem] mx-auto pb-24" }

import { computed, onMounted } from "vue"
  import { useCompanyStore } from "@/store/company"
  import { useRoute } from "vue-router"
  import { record } from "@/utils/analytics"

  // components
  import AmvContainer from "@/components/workbean-page/about/AmvContainer.vue"
  import BatContainer from "@/components/workbean-page/about/BatContainer.vue"
  import DetailsContainer from "@/components/job-page/DetailsContainer.vue"
  import OfficeContainer from "@/components/workbean-page/about/OfficeContainer.vue"
  import BadgeContainer from "@/components/workbean-page/about/BadgeContainer.vue"
  import ConnectContainer from "@/components/workbean-page/about/ConnectContainer.vue"
  import FaqContainer from "@/components/workbean-page/about/FaqContainer.vue"
  import CoreValueContainer from "@/components/workbean-page/about/CoreValue.vue"
  import PeopleContainer from "@/components/workbean-page/about/PeopleContainer.vue"
  import CovidContainer from "@/components/workbean-page/about/CovidResponse.vue"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AboutPage',
  setup(__props) {

  const companyStore = useCompanyStore()
  const route = useRoute()

  const companyDetails = computed(() => companyStore.companyDetails)
  const companyData = computed(() => [
    {
      icon: "workbean-world",
      description: "Location",
      title: companyDetails.value.location.city || "",
    },
    {
      icon: "workbean-idea",
      description: "Year founded",
      title: companyDetails.value.year_founded || "",
    },
    {
      icon: "workbean-building",
      description: "Company type",
      title: companyDetails.value.company_type || "",
    },
    {
      icon: "workbean-job",
      description: "Work setup",
      title: companyDetails.value.work_setup || "",
    },
    {
      icon: "workbean-group-user",
      description: "Employee count",
      title: companyDetails.value.number_of_employees || "",
    },
    {
      icon: "workbean-group-user",
      description: "Average age",
      title: companyDetails.value.average_age || "",
    },
  ])
  onMounted(() => {
    record({
      event: "CompanyViewPage",
      attributes: {
        link: route.fullPath,
        company_id: companyDetails.value.company_id,
      },
    })
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(DetailsContainer, {
      collection: companyData.value,
      type: "Company details",
      color: companyDetails.value.brand_color || '#7442c8'
    }, null, 8, ["collection", "color"]),
    (companyDetails.value.about && companyDetails.value.about.length)
      ? (_openBlock(), _createBlock(AmvContainer, {
          key: 0,
          type: "About",
          description: companyDetails.value.about
        }, null, 8, ["description"]))
      : _createCommentVNode("", true),
    (companyDetails.value.mission && companyDetails.value.mission.length)
      ? (_openBlock(), _createBlock(AmvContainer, {
          key: 1,
          type: "Mission",
          description: companyDetails.value.mission
        }, null, 8, ["description"]))
      : _createCommentVNode("", true),
    (companyDetails.value.vision && companyDetails.value.vision.length)
      ? (_openBlock(), _createBlock(AmvContainer, {
          key: 2,
          type: "Vision",
          description: companyDetails.value.vision
        }, null, 8, ["description"]))
      : _createCommentVNode("", true),
    (companyDetails.value.core_value && companyDetails.value.core_value.length)
      ? (_openBlock(), _createBlock(CoreValueContainer, {
          key: 3,
          "core-data": companyDetails.value.core_value,
          "brand-color": companyDetails.value.brand_color
        }, null, 8, ["core-data", "brand-color"]))
      : _createCommentVNode("", true),
    (companyDetails.value.leadership && companyDetails.value.leadership.length)
      ? (_openBlock(), _createBlock(PeopleContainer, {
          key: 4,
          "people-data": companyDetails.value.leadership
        }, null, 8, ["people-data"]))
      : _createCommentVNode("", true),
    (companyDetails.value.benefits && companyDetails.value.benefits.length)
      ? (_openBlock(), _createBlock(BatContainer, {
          key: 5,
          type: "benefits",
          bat: companyDetails.value.benefits
        }, null, 8, ["bat"]))
      : _createCommentVNode("", true),
    (companyDetails.value.amenities && companyDetails.value.amenities.length)
      ? (_openBlock(), _createBlock(BatContainer, {
          key: 6,
          type: "amenities",
          bat: companyDetails.value.amenities
        }, null, 8, ["bat"]))
      : _createCommentVNode("", true),
    (companyDetails.value.technologies && companyDetails.value.technologies.length)
      ? (_openBlock(), _createBlock(BatContainer, {
          key: 7,
          type: "tech stack",
          bat: companyDetails.value.technologies
        }, null, 8, ["bat"]))
      : _createCommentVNode("", true),
    (companyDetails.value.covid_response)
      ? (_openBlock(), _createBlock(CovidContainer, {
          key: 8,
          details: companyDetails.value.covid_response
        }, null, 8, ["details"]))
      : _createCommentVNode("", true),
    (companyDetails.value.location)
      ? (_openBlock(), _createBlock(OfficeContainer, {
          key: 9,
          address: {
        city: companyDetails.value.location.city,
        country: companyDetails.value.location.country,
        fullAddress: companyDetails.value.location.full_address,
        coordinates: companyDetails.value.location.coordinates,
        area: companyDetails.value.location.area,
      },
          "company-logo": companyDetails.value.logo
        }, null, 8, ["address", "company-logo"]))
      : _createCommentVNode("", true),
    false
      ? (_openBlock(), _createBlock(BadgeContainer, { key: 10 }))
      : _createCommentVNode("", true),
    ((companyDetails.value.socials && companyDetails.value.socials.length) || companyDetails.value.url)
      ? (_openBlock(), _createBlock(ConnectContainer, {
          key: 11,
          socials: companyDetails.value.socials,
          company: companyDetails.value.name,
          color: companyDetails.value.brand_color,
          url: companyDetails.value.url
        }, null, 8, ["socials", "company", "color", "url"]))
      : _createCommentVNode("", true)
  ]))
}
}

})